// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._5ral1f51{object-fit:contain}
._bfhku67f{background-color:#fff}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-card/dist/esm/card/ui/imageRenderer/imageRendererV2.compiled.css"],"names":[],"mappings":"AAAA,WAAW,kBAAkB;AAC7B,WAAW,qBAAqB","sourcesContent":["._5ral1f51{object-fit:contain}\n._bfhku67f{background-color:#fff}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
